import Cookies from "js-cookie";
import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoute = () => {
  let isAuthenticated = Cookies.get("access_token");
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
